const { jQuery } = window;

export default class DisabledButtonResetter {
  constructor(selector) {
    this.buttonSelector = selector;
    this.loaded = false;
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    jQuery(window).on("load", () => {
      this.enableButtons();
      this.loaded = true;
    });
    jQuery(window).on("pageshow", () => {
      // Mobile Safariなどload/unloadイベントが発生しないブラウザはpageshowイベントでリセットする
      if (this.onloaded) {
        this.loaded = false;
      } else {
        this.enableButtons();
      }
    });
  }

  enableButtons() {
    jQuery(this.buttonSelector).each((_idx, element) => {
      const $element = jQuery(element);
      // jquery-ujsのrails.jsで無効にした要素の場合はdata属性に退避されている通常時のコンテンツを戻す
      if ($element.data("ujs:enable-with")) {
        $element.html($element.data("ujs:enable-with"));
      }
      // 要素の状態を有効にする
      $element.prop("disabled", false);
    });
  }
}
